import * as Yup from 'yup'

export const validationSchema = () =>
  Yup.object({
    task_type: Yup.object().nullable().required('Выберите тип задачи'),
    name: Yup.string()
      .trim()
      .required('Введите название шаблона')
      .max(200, 'Название не должно превышать 200 символов'),
    content: Yup.string().test(
      'no-html-tags',
      'Введите текст описания',
      function (value, context) {
        const cleanedValue = value?.replace(/<[^>]*>/g, '')
        if (cleanedValue?.trim() === '') {
          return context.createError({ message: 'Введите текст описания' })
        } else {
          return true
        }
      }
    ),
  })
